var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7098 7.82609C18.7098 9.93918 16.9968 11.6522 14.8837 11.6522C12.7706 11.6522 11.0576 9.93918 11.0576 7.82609C11.0576 5.713 12.7706 4 14.8837 4C16.9968 4 18.7098 5.713 18.7098 7.82609Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95652 20.0172V21.8551C5.95652 23.616 7.38402 25.0435 9.14493 25.0435H20.6232C22.3841 25.0435 23.8116 23.616 23.8116 21.8551V20.1591C23.8116 18.7131 22.9399 17.407 21.5689 16.9472C19.6094 16.29 17.1239 15.4783 14.8841 15.4783C12.6904 15.4783 9.76457 16.2568 8.02922 16.9063C6.74277 17.3878 5.95652 18.6436 5.95652 20.0172Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8841 16.4348C12.8539 16.4348 10.0508 17.171 8.3645 17.8021C7.48967 18.1296 6.91304 19.0004 6.91304 20.0172V21.8551C6.91304 23.0877 7.91229 24.0869 9.14493 24.0869H20.6232C21.8558 24.0869 22.8551 23.0877 22.8551 21.8551V20.1591C22.8551 19.0922 22.2165 18.1733 21.2648 17.8541C19.2778 17.1877 16.9413 16.4348 14.8841 16.4348ZM7.69394 16.0105C9.4784 15.3426 12.527 14.5217 14.8841 14.5217C17.3065 14.5217 19.941 15.3923 21.8731 16.0403C23.6633 16.6407 24.7681 18.334 24.7681 20.1591V21.8551C24.7681 24.1442 22.9124 26 20.6232 26H9.14493C6.85575 26 5 24.1442 5 21.8551V20.0172C5 18.2868 5.99587 16.646 7.69394 16.0105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile-active.f023360d75ba6ccf3b0d23b0a3b7e810.svg";
export { ForwardRef as ReactComponent };